export default __webpack_public_path__ + "static/media/avatar.ec4c624b.png";